export const PM_DATA_START = '2019-01-01';

// Is used to be able to have a different flow between HTML template mail & copy text flow for PM mails
export const MAIL_TYPE = {
  HOTEL: '1',
  WHOLESALER: '2',
} as const;

export type MailType = (typeof MAIL_TYPE)[keyof typeof MAIL_TYPE];
